var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClubLaRiveraWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Club_LaRivera_White",
    xmlns: "http://www.w3.org/2000/svg",
    width: 218.09,
    height: 218.1,
    viewBox: "0 0 218.09 218.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f5f5f5;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    className: "cls-1",
    d: "M218.1,41.533a9.592,9.592,0,0,0-9.581-9.588H166.556V18.619A9.588,9.588,0,0,0,163.359,0H54.735a9.588,9.588,0,0,0-3.191,18.625V31.948H9.577a9.588,9.588,0,0,0-3.2,18.619V195.745a3.2,3.2,0,0,0,3.2,3.187h61.13L52.818,212.349a3.2,3.2,0,0,0,1.914,5.751H163.357a3.2,3.2,0,0,0,1.921-5.751l-17.886-13.418h61.13a3.2,3.2,0,0,0,3.187-3.187h0V50.564a9.588,9.588,0,0,0,6.395-9.031Zm-51.54,9.581h38.761V159.739H166.556ZM54.735,6.388H163.359a3.2,3.2,0,1,1,0,6.388H67.513a3.2,3.2,0,0,0,0,6.388h92.668V192.539h-6.4V124.6a3.2,3.2,0,0,0-3.2-3.208H67.513a3.2,3.2,0,0,0-3.191,3.2v67.982H57.928V15.959a3.2,3.2,0,0,0-3.2-3.2h0a3.2,3.2,0,0,1,0-6.388Zm57.51,186.183V153.348H134.6v39.192Zm-28.755,0V153.348h22.364v39.192ZM137.8,146.991H80.3a3.2,3.2,0,0,0-3.2,3.2h0v42.383H70.711v-64.78h76.681v64.75H141V150.158a3.2,3.2,0,0,0-3.2-3.2ZM51.542,51.115V159.739H12.776V51.115ZM9.577,38.336H51.542v6.388H9.577a3.2,3.2,0,1,1,0-6.388Zm3.2,127.791H51.542v26.416H12.776ZM153.771,211.71H64.32l17.04-12.779h55.376Zm12.779-19.167V166.127h38.761v26.416ZM208.521,44.724H166.55V38.336h41.971a3.2,3.2,0,0,1,0,6.388Z",
    transform: "translate(-0.011)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    className: "cls-1",
    d: "M35.619,142.038h19.6a3.2,3.2,0,0,0,3.2-3.2V100.487a3.2,3.2,0,0,0-3.2-3.2h-19.6a3.2,3.2,0,0,0-3.191,3.2h0v38.336a3.2,3.2,0,0,0,3.191,3.215Zm3.2-38.336h13.2v31.946h-13.2Z",
    transform: "translate(-13.273 -39.787)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    className: "cls-1",
    d: "M315.391,97.29h-19.6a3.2,3.2,0,0,0-3.191,3.2h0v38.336a3.2,3.2,0,0,0,3.191,3.215h19.6a3.2,3.2,0,0,0,3.191-3.2V100.487a3.2,3.2,0,0,0-3.191-3.2Zm-3.2,38.342h-13.2V103.715h13.2Z",
    transform: "translate(-119.665 -39.787)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    className: "cls-1",
    d: "M35.619,228.5h19.6a3.2,3.2,0,0,0,3.2-3.191V186.971a3.2,3.2,0,0,0-3.2-3.191h-19.6a3.191,3.191,0,0,0-3.191,3.191v38.342A3.191,3.191,0,0,0,35.619,228.5Zm3.2-38.336h13.2v31.917h-13.2Z",
    transform: "translate(-13.273 -75.156)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    className: "cls-1",
    d: "M315.391,183.78h-19.6a3.191,3.191,0,0,0-3.191,3.191v38.342a3.191,3.191,0,0,0,3.191,3.191h19.6a3.191,3.191,0,0,0,3.191-3.191V186.971A3.191,3.191,0,0,0,315.391,183.78Zm-3.2,38.336h-13.2V190.2h13.2Z",
    transform: "translate(-119.665 -75.156)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    className: "cls-1",
    d: "M143.951,74.48h-19.6a3.2,3.2,0,0,0-3.191,3.2h0v38.336a3.2,3.2,0,0,0,3.191,3.2h19.6a3.2,3.2,0,0,0,3.191-3.2V77.677A3.2,3.2,0,0,0,143.951,74.48Zm-3.2,38.343H127.57V80.905h13.2Z",
    transform: "translate(-49.557 -30.458)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    className: "cls-1",
    d: "M228.248,75.93h-19.57a3.2,3.2,0,0,0-3.2,3.187h0v38.34a3.2,3.2,0,0,0,3.2,3.2h19.57a3.2,3.2,0,0,0,3.191-3.2V79.117A3.191,3.191,0,0,0,228.248,75.93Zm-3.2,38.336H211.87V82.349h13.2Z",
    transform: "translate(-84.039 -31.052)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClubLaRiveraWhite);
export default __webpack_public_path__ + "static/media/Club_LaRivera_White.8c6db0b4963b62147658f6bef61561e9.svg";
export { ForwardRef as ReactComponent };